import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { FormikProps } from "formik";
import ComponentHeader, { ComponentHeaderProps } from "../../components/componentHeader/componentHeader";
import { FormGroup } from "../../components/form";
import FormContainer from "../../components/form/FormContainer";
import { apiClient } from "../customHooks";
import ComponentProviderHeader from "../../components/componentHeader/componentProviderHeader";
import { INavItem, useGlobalContext } from "../GlobalContext";

export interface BaseProps {
  headerLabel: string;
  apiClient: apiClient;
  formBody: FormGroup;
  formContext?: any;
  formLabel?: string;
  isNavHidden?: boolean;
  disabled: boolean;
  data?: any;
  editPath: string;
  backPath?: string;
  cancelPath?: string;
  submitPath?: string | null;
  showEdit?: boolean;
  showBack?: boolean;
  showInternalNotes?: boolean;
  submitBtnTitle?: string;
  noValidateBtnTitle?: string;
  showNoValidateBtn?: boolean;
  customNav?: INavItem;
  saveSuccessCB?: (data?: any) => void;
  saveErrorCB?: (error?: any) => void;
  getInitialValues?: (data: any, formik: FormikProps<any>) => void;
  customSubmit?: (data: any, isSubmitting: (isSubmitting: boolean) => void, isValid: boolean) => void;
  id: any;
  submitApiPath?: string;
  hideCancelButton?: boolean;
  hideSubmitButton?: boolean;
  doFetch?: boolean;
  displayEmptyForm?: boolean;
}

export default function BaseComponent({
  headerLabel,
  apiClient,
  formBody,
  formContext,
  disabled,
  data,
  editPath,
  backPath,
  cancelPath,
  submitPath,
  showEdit,
  showBack,
  isNavHidden,
  formLabel,
  showInternalNotes,
  submitBtnTitle,
  noValidateBtnTitle,
  showNoValidateBtn,
  customNav,
  saveSuccessCB,
  saveErrorCB,
  getInitialValues,
  customSubmit,
  id,
  submitApiPath,
  hideCancelButton,
  hideSubmitButton,
  doFetch,
  displayEmptyForm,
}: BaseProps) {
  const [context] = useState({});
  const location = useLocation();
  const {
    accountInfo: { isInternal, isProvider },
  } = useGlobalContext();

  const [headerData, setHeaderData] = useState<ComponentHeaderProps>({
    dateCreated: isInternal ? data?.dateCreated : null,
    userCreated: isInternal ? data?.userCreated : null,
    showEdit: showEdit !== undefined ? showEdit : disabled,
    editPath: `${location.pathname}/${editPath}`,
    showBack: showBack ?? (!disabled && backPath !== null),
    backPath: backPath,
  });

  function getHeaderData(data: any, formik: FormikProps<any>) {
    const headerData: ComponentHeaderProps = {
      dateCreated: isInternal ? data?.dateCreated : null,
      userCreated: isInternal ? data?.userCreated : null,
      showEdit: showEdit ?? disabled,
      editPath: `${location.pathname}/${editPath}`,
      showBack: showBack ?? (!disabled && backPath !== null),
      backPath: backPath ?? "..",
    };
    setHeaderData(headerData);
    getInitialValues?.(data, formik);
  }
  const { addNavItem } = useGlobalContext();

  const didInit = useRef(false);
  useEffect(() => {
    if (!didInit.current) {
      didInit.current = true;
      if (!isNavHidden) {
        addNavItem(
          customNav ?? {
            label: headerLabel,
            id: headerLabel.replace(/\s+/g, ""),
          }
        );
      }
    }
  }, []);

  return (
    <>
      {" "}
      <div className="flex flex-column align-items-start w-full p-5 pl-container">
        {!isNavHidden && <div id={customNav ? customNav.id : headerLabel.replace(/\s+/g, "")}></div>}
        {isProvider ? <ComponentProviderHeader {...headerData} label={headerLabel} /> : <ComponentHeader {...headerData} label={headerLabel} />}

        <FormContainer
          id={id}
          apiClient={apiClient}
          formBody={formBody}
          formTitle={formLabel}
          formContext={formContext ?? context}
          getInitialValues={getHeaderData}
          disabled={disabled}
          data={data}
          cancelPath={cancelPath}
          submitRoute={submitPath === undefined ? ".." : submitPath} // specifically undefined so null is seperate
          showInternalNotes={isInternal ? showInternalNotes : false}
          saveSuccessCB={saveSuccessCB}
          saveErrorCB={saveErrorCB}
          customSubmit={customSubmit}
          submitBtnTitle={submitBtnTitle}
          noValidateBtnTitle={noValidateBtnTitle}
          showNoValidateBtn={showNoValidateBtn}
          submitApiPath={submitApiPath}
          hideCancelButton={hideCancelButton}
          hideSubmitButton={hideSubmitButton}
          doFetch={doFetch ?? !disabled}
          displayEmptyForm={displayEmptyForm}
        />
      </div>
    </>
  );
}
